const isNotNullEmail = (data) => {
  const key = 'isNotNullEmail'
  const { value } = data
  const isEmpty = value === '' || value === null ? true : false
  const error = isEmpty ? key : false
  return error ? { error, data } : false
}

export default isNotNullEmail
